const identifyContent = () => {
    const postContentDiv = document.querySelector('.post-content');
    const keywordList = document.querySelector('.keywordList');
    const childElements = Array.from(postContentDiv.children);

    childElements.forEach((element, index) => {
        if (element.tagName.toLowerCase() === 'h2') {
            const strongElement = element.textContent;

            if (strongElement) {
                const containerKeyword = document.querySelector('.container-keyWords');

                if (containerKeyword) {
                    containerKeyword.classList.remove('hidden');
                }

                if (!element.id) {
                    element.id = `paragraph-${index}`;
                }

                const anchor = document.createElement('a');
                const listItem = document.createElement('li');

                anchor.href = `#${element.id}`;
                anchor.textContent = strongElement;

                anchor.classList.add('cursor-pointer');

                anchor.addEventListener('click', (event) => {
                    event.preventDefault();

                    const bannerHeight = document.querySelector('.container-banner').offsetHeight;
                    const targetElement = document.getElementById(element.id);

                    const scrollToElement = () => {
                        const elementPosition =
                            targetElement.getBoundingClientRect().top + window.scrollY - bannerHeight;
                        window.scrollTo({ top: elementPosition, behavior: 'smooth' });
                    };

                    scrollToElement();
                });

                listItem.appendChild(anchor);
                keywordList.appendChild(listItem);
            }
        }
    });

    let dataIndex = 0;   
    document.querySelectorAll('.keywordList li').forEach((li) => {
        li.setAttribute('data-index', dataIndex++);
    })

    function getIndexPosition(index, array) {
        const length = array.length;
        if (length === 0) return null;
        
        const middle = Math.floor(length / 2);
        
        if (index < middle) {
            return 'início';
        } else if (index === middle) {
            return 'meio';
        } else {
            return 'final';
        }
    }
    
    let keywordListItems = document.querySelectorAll('.keywordList li');
    let keywordListItemsArray = Array.from(keywordListItems, (item) => parseInt(item.getAttribute('data-index')));
    
    let lastScrollTop = window.scrollY;
    
    const scrollHandler = () => {
        const bannerHeight = document.querySelector('.container-banner').offsetHeight;
        const topOffset = bannerHeight + 120;
        const earlyActivationOffset = 20;
        
        let activeElement = null;
        
        const currentScrollTop = window.scrollY;
        const scrollingUp = currentScrollTop < lastScrollTop;
        lastScrollTop = currentScrollTop;
        
        childElements.forEach((element, index) => {
            const anchor = document.querySelector(`.keywordList a[href="#paragraph-${index}"]`);
    
            if (anchor) {
                const rect = element.getBoundingClientRect();
    
                if (rect.top <= topOffset + earlyActivationOffset) {
                    document.querySelectorAll('.keywordList li').forEach((li) => {
                        li.classList.remove('active');
                    });

                    anchor.parentElement.classList.add('active');
                    activeElement = anchor.parentElement;
                }
            }
        });
    
        if (activeElement) {
            const dataIndex = parseInt(activeElement.getAttribute('data-index'));
            const position = getIndexPosition(dataIndex, keywordListItemsArray);
    
            if (position === 'meio' || position === 'final' || scrollingUp) {
                const containerKeyword = document.querySelector('.keywordListContainer');
                if (containerKeyword) {
                    containerKeyword.scrollTo({
                        top: activeElement.offsetTop - containerKeyword.offsetTop - (containerKeyword.clientHeight / 2) + (activeElement.clientHeight / 2),
                        behavior: 'smooth',
                    });
                }
            }
        }
    }; 

    window.addEventListener('scroll', scrollHandler);
};

identifyContent();
